export const INIT_VIEW = "INIT_VIEW";
export const SLIVER_VIEW = "SLIVER_VIEW";
export const TESTIMONY_VIEW = "TESTIMONY_VIEW";
export const SLIVER_TO_TESTIMONY_VIEW = "SLIVER_TO_TESTIMONY_VIEW";
export const TESTIMONY_TO_SLIVER_VIEW = "TESTIMONY_TO_SLIVER_VIEW";
